import React from 'react';
import {
  TextField,
  SelectField,
} from '../../../ui/FormElement';

export default function NewManager({
  roles,
  enableFields,
  isAutomaticOnboarderForm,
  selectEnterprise, enterprises,
  onEnterpriseChange,
  isAdministratorForm,
  selectTeam,
  teams,
  selectMemberTeam,
  onMemberTeamChange,
  filteredMembers,
  setFieldValue,
  paymentMethods,
  isBillingManagerForm,
  selectPaymentMethod,
}) {
  return (
    <>
      <SelectField
        name="role"
        label={(
          <>
            <span>Permission Level</span>
            <abbr title="required">*</abbr>
          </>
        )}
        placeholder="Choose Permission Level..."
        options={roles}
        onCustomonChange={(option) => enableFields(option)}
      />

      <TextField
        name="firstName"
        label={(
          <>
            <span>First Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="lastName"
        label={(
          <>
            <span>Last Name</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />

      <TextField
        name="email"
        type="email"
        label={(
          <>
            <span>Email</span>
            <abbr title="required">*</abbr>
          </>
        )}
      />
      {isAutomaticOnboarderForm && (
        <TextField
          name="password"
          type="password"
          label={(
            <>
              <span>Password</span>
              <abbr title="required">*</abbr>
            </>
          )}
        />
      )}

      <SelectField
        ref={selectEnterprise}
        name="enterprises"
        label={(
          <>
            <span>Enterprise</span>
            <abbr title="required">*</abbr>
          </>
        )}
        placeholder={
          enterprises === undefined
            ? 'Enterprise is loading ...'
            : 'Choose Enterprise...'
        }
        options={enterprises}
        onCustomonChange={(option) => onEnterpriseChange(option?.value)}

        menuPlacement="auto"
      />

      {!isAdministratorForm && (
        <SelectField
          ref={selectTeam}
          name="teams"
          label={(
            <>
              <span>Select Teams To Manage</span>
              <abbr title="required">*</abbr>
            </>
          )}
          placeholder="Choose Teams..."
          options={teams}
          isMulti
          menuPlacement="auto"
        />
      )}

      {isBillingManagerForm && (
      <SelectField
        ref={selectPaymentMethod}
        name="paymentMethod"
        label={(
          <span>Select Payment Method</span>
        )}
        placeholder="Choose Payment Method ..."
        options={paymentMethods
          ? paymentMethods.map((item) => ({ value: item.id, label: item.attributes.label }))
          : []}
        menuPlacement="auto"
      />
      )}

      <hr />

      <SelectField
        ref={selectMemberTeam}
        name="member_team"
        label={(
          <>
            <span>Select Team For Manager's Member</span>
            <abbr title="required">*</abbr>
          </>
        )}
        placeholder="Choose Team..."
        options={teams}
        menuPlacement="auto"
      />

    </>
  );
}
